import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const InvoiceSave = createAsyncThunk(
  "InvoiceSave",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.INVOICE?.SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const InvoiceDownload = createAsyncThunk(
  "InvoiceDownload",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: `${API_URL.BASEURL}${API_URL?.INVOICE?.DOWNLOAD_PDF}?invoiceno=${data?.invoiceNo}`,
        },
        false
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const InvoiceGetList = createAsyncThunk(
  "InvoiceGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: `${API_URL.BASEURL}${API_URL?.INVOICE?.GETLIST}?invoicetype_term=${data?.invoicetype_term}`,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const GetWalletDataList = createAsyncThunk(
  "GetWalletDataList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: `${API_URL.BASEURL}${API_URL?.INVOICE?.GET_WALLET_DATA_LIST}`,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const CreatePayment = createAsyncThunk(
  "CREATEPAYMENT",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.INVOICE?.CREATEPAYMENT,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const TopupWalletPayment = createAsyncThunk(
  "TOPUPWALLETPAYMENT",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.INVOICE?.TOPUPWALLETPAYMENT,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) { }
  }
);

export const AutoPayment = createAsyncThunk(
  "AUTOPAYMENT",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.INVOICE?.AUTO_PAYMENT,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const PaymentStatusCheck = createAsyncThunk(
  "PAYMENTSTATUSCHECK",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASEURL +
            API_URL?.INVOICE?.PAYMENTSTATUSCHECK +
            "?sessionId=" +
            data,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const InvoiceTransaction = createAsyncThunk(
  "InvoiceTransaction",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.TRANSACTION?.GETLIST,
          body: data,
        },
        false
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

export const PaymentMethod_CreatePayment = createAsyncThunk(
  "PAYMENTMETHOD_CREATEPAYMENT",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL?.PAYMENTMETHOD?.CREATEPAYMENT,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const PaymentMethod_PaymentStatusCheck = createAsyncThunk(
  "PAYMENTMETHOD_PAYMENTSTATUSCHECK",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASEURL +
            API_URL?.PAYMENTMETHOD?.PAYMENTSTATUSCHECK +
            "?sessionId=" +
            data,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const PaymentMethodList = createAsyncThunk(
  "PaymentMethodList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: `${API_URL.BASEURL}${API_URL?.PAYMENTMETHOD?.GETLIST}`,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const FetchInvoiseList = createAsyncThunk(
  "FetchInvoiseList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: `${API_URL.BASEURL}${API_URL?.INVOICE?.LIST}?year=${data}`,
          //   body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
export const FetchInvoiseById = createAsyncThunk(
  "FetchInvoiseById",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "GET",
          url: `${API_URL.BASEURL}${API_URL?.INVOICE?.GET_INVOISE_BY_ID}?Id=${data}`,
          //   body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const PaymentMethodSetPrimary = createAsyncThunk(
  "PaymentMethodSetPrimaryList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "Delete",
          url: `${API_URL.BASEURL}${API_URL?.PAYMENTMETHOD?.SETPRIMARY}`,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  InvoiceSaveData: {
    data: null,
    error: null,
  },
  InvoiceDownloadData: {
    data: null,
    error: null,
  },
};

const OrderSlice = createSlice({
  name: "INVOICE",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(InvoiceSave.fulfilled, (state, action) => {
        state.InvoiceSaveData.data = action.payload;
      })
      .addCase(InvoiceSave.rejected, (state, action) => {
        state.InvoiceSaveData.error = action.error.message;
      })
      .addCase(InvoiceDownload.fulfilled, (state, action) => {
        state.InvoiceDownloadData.data = action.payload;
      })
      .addCase(InvoiceDownload.rejected, (state, action) => {
        state.InvoiceDownloadData.error = action.error.message;
      });
  },
});

export default OrderSlice.reducer;
